//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//
/**
 * Created by z003f2zh on 07.03.2016.
 */

(function () {

    'use strict';

    angular.module('container.components')
        .directive('srsngShareBox', srsngShareBox);

    function srsngShareBox() {

        return {
            restrict: 'E',
            scope: {
                visible: '='
            },
            templateUrl: 'container/ui/app/components/share-box/share-box.html',
            controller: controller
        };

        function controller($scope) {

            $scope.close = function () {
                $scope.visible = false;
            }
        }
    }
})();